// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAppStoreOutlinedSvg from "@fishx/icons-svg/es/asn/PAppStoreOutlined";
import FishxIcon from '../components/FishxIcon';

var PAppStoreOutlined = function PAppStoreOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAppStoreOutlinedSvg
  }));
};

PAppStoreOutlined.displayName = 'PAppStoreOutlined';
export default React.forwardRef(PAppStoreOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAppStoreOutlined.js
// module id = 3210
// module chunks = 0